import { useState } from 'react';
import styled from 'styled-components';
import { LineShortener } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { getAnimation, linkChecking } from '../../helpers';

interface DescriptionProps {
  shortenedDescription?: boolean;
  text?: string;
  _marginTop?: number;
}

export function Description({
  text,
  shortenedDescription = true,
  _marginTop = 0
}: DescriptionProps) {
  const { messageSeeMoreButton, messageSeeLessButton } = useSettings();

  const [shortened, setShortened] = useState(shortenedDescription);
  const [isShorteningPossible, setIsShorteningPossible] =
    useState(shortenedDescription);

  const onToggleDescriptionSize = () => {
    setShortened(!shortened);
  };

  return (
    <Container _marginTop={_marginTop}>
      <LineShortener
        shortenedLines={3}
        shortened={shortened}
        onPossibilityChange={setIsShorteningPossible}
      >
        <Context
          dangerouslySetInnerHTML={{ __html: linkChecking(text || '') }}
        />
      </LineShortener>
      {isShorteningPossible && (
        <Control onClick={onToggleDescriptionSize}>
          {shortened ? messageSeeMoreButton : messageSeeLessButton}
        </Control>
      )}
    </Container>
  );
}

const Container = styled.div<{
  _marginTop?: number;
}>`
  font-size: 13px;
  line-height: 1.38;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  white-space: normal;
  margin-bottom: 12px;
  margin-top: ${({ _marginTop }) => _marginTop}px;
`;

const Control = styled.div`
  cursor: pointer;
  font-size: 13px;
  line-height: 1.38;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  align-self: flex-start;
  opacity: 0.5;
  transition: ${getAnimation('opacity')};

  &:hover {
    opacity: 1;
  }
`;

const Context = styled.div`
  & p:first-child {
    margin-top: 0;
  }

  & p:last-child {
    margin-bottom: 0;
  }

  & img {
    max-width: 100%;
  }
`;
